/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// TODO Unit testy.
/**
 * Továrna na zdroje funkcionalit v podobě HTML image elementů.
 * @implements {ViewerSourceFactory}
 */
class DivViewerSourceFactory {
  /**
   * Vytvoří instanci.
   * @param {Class.<DivViewerSource>} DivViewerSource Konstruktor zdroje obrázkového elementu.
   * @param {ViewerFrameFactory} frameFactory
   */
  constructor(DivViewerSource, frameFactory) {
    this.DivViewerSource = DivViewerSource;
    this.frameFactory = frameFactory;
    this.parentEl = null;
  }

  /** @inheritdoc */
  create() {
    return new this.DivViewerSource(this.frameFactory, this.parentEl);
  }

  /** @inheritdoc */
  delete(source) {
    return source.destroy();
  }

  /** @inheritdoc */
  setParentEl(parentEl) {
    this.parentEl = parentEl;
  }
}

export default DivViewerSourceFactory;
